import { SpaceSelector } from "components/admin/SpaceSelector";
import React from "react";

export const RoomSelector = () => {
  return <SpaceSelector />;
};
